while (window.requireQueue.length > 0) {
  const requireQueueBackup = window.requireQueue;
  window.requireQueue = [];
  requireQueueBackup.forEach((cb) => cb());
}

delete window.requireQueue;
delete window.queueRequire;



// WEBPACK FOOTER //
// ./app/scripts/entry/cleanup.js